import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { PercentComparator } from '../../../components/common/PercentComparator';
import { DateComparator } from '../../../components/common/DateComparator';

export const EditParameterConfigHeaders = (onClickEditExistingRecords, onClickDeleteLineItem, value, userRole) => {
    return [
        {
            field: "uniqueId",
            headerName: "ID",
        },
        {
            field: "plant",
            headerName: "Plant",
        },
        {
            field: "purchasingGroup",
            headerName: "Purchasing Group",
        },
        {
            field: "mrpController",
            headerName: "MRP Controller",
        },
        {
            field: "scode",
            headerName: "S-Code (Ext Material Group)",

        },
        {
            field: "materialType",
            headerName: "Material Type",
        },
        {
            field: "materialGroup",
            headerName: "Material Group",
        },
        {
            field: "material",
            headerName: "Material",
            cellRenderer: (response) => {
                return (
                    <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${response?.value}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                )
            }
        },
        {
            field: "supplier",
            headerName: "Supplier",
        },
        {
            field: "coolingPeriod",
            headerName: "Cooling Period in Days",
        },
        {
            field: "overdueWorkflowDays",
            headerName: "Overdue WorkFlow Days",
        },
        {
            field: "lowLeadTimeVariationCategory",
            headerName: "Low Lead Time Variation Category",
        },
        {
            field: "mediumLeadTimeVariationCategory",
            headerName: "Meduim Lead time Variation Category",
        },
        {
            field: "highLeadTimeVariationCategory",
            headerName: "High Lead Time Variation Category",
            comparator: PercentComparator,
        },
        {
            field: "createdOn",
            headerName: "Created On",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',
        },
        {
            field: "updatedOn",
            headerName: "Updated On",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',
        },
        {
            field: "Actions",
            headerName: "Actions",
            width: 120,
            cellRenderer: (response) => (
                <div className="btn-wrapper" style={{ marginTop: 6 }} >
                    <EditIcon onClick={() => onClickEditExistingRecords(response)} style={{ cursor: 'pointer' }} />
                    <DeleteIcon onClick={() => onClickDeleteLineItem(response)} style={{ cursor: 'pointer' }} />
                </div>
            ),
            pinned: 'right',
            lockPinned: true,
            lockPosition: true,
            hide: userRole === "Viewer" ? true : false
        },
    ]
}